/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.loading)();
	  (0, _module.anchorLink)();
	  (0, _module.resizeHeader)();
	  (0, _module.mainSlider)();
	  (0, _module.langToggle)();
	  (0, _module.menuToggle)();
	  (0, _module.movieSlider)();
	  (0, _module.recoSlider)();
	  (0, _module.scrlInit)();
	  (0, _module.accToggle)();
	  (0, _module.inputSync)();
	  (0, _module.srchToggle)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.menuToggle = exports.srchToggle = exports.langToggle = exports.inputSync = exports.scrlInit = exports.accToggle = exports.recoSlider = exports.movieSlider = exports.mainSlider = exports.resizeHeader = exports.anchorLink = exports.loading = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	} // ------------------------------------------------------------------------
	// loading
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var loading = function loading() {
	  $(window).on("load", function () {
	    $(".st-Load").addClass("loaded");
	  });
	  setTimeout(function () {
	    $(".st-Load").addClass("loaded");
	  }, 3000);
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loading = loading;
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// mainSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var mainSlider = function mainSlider() {
	  $('.mv-slider').slick({
	    autoplay: true,
	    autoplaySpeed: 5000,
	    infinite: true,
	    dots: true,
	    speed: 800,
	    slidesToShow: 1,
	    centerMode: true,
	    variableWidth: true,
	    focusOnSelect: true,
	    responsive: [{
	      breakpoint: 1024,
	      settings: {
	        slidesToShow: 1
	      }
	    }]
	  });
	}; // ------------------------------------------------------------------------
	// resizeHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.mainSlider = mainSlider;
	
	var resizeHeader = function resizeHeader() {
	  $(window).on("load scroll", function () {
	    var scrollHeight = $(this).scrollTop();
	
	    if (scrollHeight > 200) {
	      $(".st-Header").addClass("scrolled");
	    } else {
	      $(".st-Header").removeClass("scrolled");
	    }
	  });
	}; // ------------------------------------------------------------------------
	// movieSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.resizeHeader = resizeHeader;
	
	var movieSlider = function movieSlider() {
	  $('.movie-slider').slick({
	    arrows: false,
	    dots: true,
	    infinite: false,
	    speed: 500,
	    fade: true,
	    cssEase: 'ease',
	    customPaging: function customPaging(slick, index) {
	      var targetImage = slick.$slides.eq(index).find('.movie-bg').attr('data-url');
	      return '<button style="background: #000 url(' + targetImage + ') no-repeat center center/cover"/>';
	    }
	  });
	  $(".movie-wrapper").on("click", function () {
	    $(this).addClass("play");
	    videoControl("playVideo", $(this).children('iframe'));
	  });
	}; // ------------------------------------------------------------------------
	// recoSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.movieSlider = movieSlider;
	
	var recoSlider = function recoSlider() {
	  $('.reco-slider').slick({
	    // autoplay: true,
	    infinite: true,
	    speed: 1000,
	    slidesToShow: 3,
	    variableWidth: true,
	    focusOnSelect: true,
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 2
	      }
	    }]
	  });
	}; // ------------------------------------------------------------------------
	// accToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.recoSlider = recoSlider;
	
	var accToggle = function accToggle() {
	  $(".acc-toggle").on("click", function () {
	    $(this).toggleClass("open");
	    $(this).prev().toggleClass("open");
	    $(this).prev().slideToggle(300);
	  });
	  $(".acc-head-toggle").on("click", function () {
	    $(this).parent().toggleClass("open");
	    $(this).parent().next().slideToggle(300);
	  });
	}; // ------------------------------------------------------------------------
	// scrlInit
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.accToggle = accToggle;
	
	var scrlInit = function scrlInit() {
	  $('.store-list').each(function (i, e) {
	    var listWidth = $(e).outerWidth();
	    var itemWidth = 0; // 子要素のmargin含む横幅の合計値を取得
	
	    $(e).children('.store-item').each(function (i, e) {
	      itemWidth += $(e).outerWidth(true);
	    }); // 子要素の幅合計が親を上回っていたらスクロールバー適用
	
	    if (listWidth < itemWidth) {
	      $(e).addClass('store-list_scroll');
	      $(e).parent().addClass('nopadding');
	      new SimpleBar($(e)[0], {
	        autoHide: false
	      });
	    }
	  }); // マウスホイールでスクロール
	
	  if (matchMedia('(max-width: 1023px)').matches) {} else {
	    var horiElm = $('[data-simplebar]');
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      var _loop = function _loop() {
	        var elm = _step.value;
	
	        elm.onwheel = function (event) {
	          event.preventDefault();
	          var elmToScroll = elm.querySelector('.simplebar-content-wrapper');
	          clearTimeout(elmToScroll.timer);
	          elmToScroll.timer = setTimeout(function () {
	            elmToScroll.scrollTo({
	              left: event.deltaY > 0 ? elmToScroll.scrollLeft + 250 : elmToScroll.scrollLeft - 250,
	              behavior: 'smooth'
	            });
	          }, 20);
	        };
	      };
	
	      for (var _iterator = horiElm[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        _loop();
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	          _iterator["return"]();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	}; // ------------------------------------------------------------------------
	// inputSync
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.scrlInit = scrlInit;
	
	var inputSync = function inputSync() {
	  var count = 0;
	  $(".sw-Game_Searchbox form input[type='checkbox'],.sw-Game_Searchbox form input[type='radio']").change(function () {
	    var name = $(this).attr('name');
	    var value = $(this).attr('value');
	    var isChecked = $(this).prop('checked');
	
	    if (name == 'pl[]' && isChecked) {
	      $('<input type="hidden" name="pl[]" value="' + value + '">').insertBefore('.freeword input[type="text"]');
	    } else if (name == 'pl[]' && !isChecked) {
	      $('.freeword input[value="' + value + '"]').remove();
	    }
	
	    if (name == 'gr[]' && isChecked) {
	      $('<input type="hidden" name="gr[]" value="' + value + '">').insertBefore('.freeword input[type="text"]');
	    } else if (name == 'gr[]' && !isChecked) {
	      $('.freeword input[value="' + value + '"]').remove();
	    }
	
	    if (name == 'order' && value == 'published') {
	      $('.freeword input[value="scheduled"]').remove();
	      $('<input type="hidden" name="order" value="' + value + '">').insertBefore('.freeword input[type="text"]');
	    } else if (name == 'order' && value == 'scheduled') {
	      $('.freeword input[value="published"]').remove();
	      $('<input type="hidden" name="order" value="' + value + '">').insertBefore('.freeword input[type="text"]');
	    }
	  });
	  $(".sw-Game_Searchbox form input[type='text']").on('input', function () {
	    var isSet = $('.freeword input[name="s"]').val(); // console.log(isSet.length);
	
	    var value = $(this).val();
	
	    if (isSet.length == 1 && count == 0) {
	      $('<input type="hidden" name="s" value="' + value + '">').prependTo('.taxonomy');
	      count++;
	    }
	
	    if (!value) {
	      $('.taxonomy input[name="s"]').remove();
	      count = 0;
	    } else {
	      $('.taxonomy input[name="s"]').val(value);
	    }
	  });
	}; // ------------------------------------------------------------------------
	// langToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.inputSync = inputSync;
	
	var langToggle = function langToggle() {
	  $(".st-Header_Lang p").on("click", function () {
	    $(this).parent().toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// srchToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.langToggle = langToggle;
	
	var srchToggle = function srchToggle() {
	  $(".sw-Game_Searchbox_Toggle").on("click", function () {
	    $(this).toggleClass("open");
	    $(this).next().toggleClass("open");
	    $(this).next().slideToggle(300);
	  });
	}; // ------------------------------------------------------------------------
	// menuToggle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.srchToggle = srchToggle;
	
	var menuToggle = function menuToggle() {
	  $(".header-hamburger").on("click", function () {
	    $(this).toggleClass("open");
	    $(".st-Header_Nav").toggleClass("open");
	  });
	};
	
	exports.menuToggle = menuToggle;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// game/app.bundle.js